import { Component, EventEmitter, Output } from '@angular/core';
import { ProductService } from '../../services/product.service';
import { HomeService } from 'src/app/pages/home/services/home.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css'],
})
export class FilterComponent {
  @Output() filtersChanged = new EventEmitter<any>();

  selectedSort: string = '';
  selectedColor: string = '';
  selectedSize: string = '';
  selectedCategory: string = '';
  selectedColors: string[] = [];
  selectedSizes: string[] = [];

  colors: string[] = [];
  sizes: string[] = [];

  categories = [{ name: 'Running Shoes', id: 'running' }];

  constructor(
    private productService: ProductService,
    private categoryServcie: HomeService
  ) {}

  ngOnInit() {
    this.productService.getAllSizes().subscribe((res) => {
      if (res) {
        this.sizes = res;
        this.sortSizes(); // sort sizes after fetching
      }
    });

    this.productService.getAllColors().subscribe((res) => {
      if (res) {
        this.colors = res;
      }
    });

    this.categoryServcie.getCategories().subscribe((res) => {
      if (res) {
        this.categories = res;
      }
    });
  }

  sortSizes() {
    const sizes = (this.sizes || [])
      .map((size: string | null) => (size || '').trim())
      .filter((size) => size);

    const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL'];

    const yearsSizes = sizes
      .filter((size) => size.toLowerCase().includes('year'))
      .sort((a, b) => {
        const numA = parseInt(a);
        const numB = parseInt(b);
        return isNaN(numA) || isNaN(numB) ? a.localeCompare(b) : numA - numB;
      });

    const normalSizes = sizes
      .filter((size) => !size.toLowerCase().includes('year'))
      .sort((a, b) => {
        const labelA = a.split('=')[0].trim().replace(/\s/g, '').toUpperCase();
        const labelB = b.split('=')[0].trim().replace(/\s/g, '').toUpperCase();

        const indexA = sizeOrder.indexOf(labelA);
        const indexB = sizeOrder.indexOf(labelB);

        if (indexA === -1 && indexB === -1) return labelA.localeCompare(labelB);
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;

        return indexA - indexB;
      });

    this.sizes = [...yearsSizes, ...normalSizes];
  }

  onColorClick(color: string) {
    if (this.selectedColors.includes(color)) {
      this.selectedColors = this.selectedColors.filter((c) => c !== color);
    } else {
      this.selectedColors.push(color);
    }
    this.emitFilters();
  }

  onSizeToggle(size: string) {
    if (this.selectedSizes.includes(size)) {
      this.selectedSizes = this.selectedSizes.filter((s) => s !== size);
    } else {
      this.selectedSizes.push(size);
    }
    this.emitFilters();
  }

  emitFilters() {
    this.filtersChanged.emit({
      colors: this.selectedColors,
      sizes: this.selectedSizes,
      sort: this.selectedSort,
      category: this.selectedCategory,
    });
  }

  onFilterChange() {
    this.emitFilters();
  }

  clearFilters() {
    this.selectedSort = '';
    this.selectedColors = [];
    this.selectedSizes = [];
    this.selectedCategory = '';

    this.emitFilters();
  }
}
